var option_webview_default = {
  "option": "Pyb8W",
  "user_choice": "Ak2Tz",
  "check": "U1mJl",
  "image": "T0Ib9",
  "input": "OoZT-",
  "title": "WLI4y",
  "centered": "pFyKQ",
  "with_result": "A5kY-",
  "list": "EIILa",
  "with_image": "SPLwP",
  "progress": "tl57u",
  "progress_value": "klsNG",
  "label": "gZ1hR",
  "cta": "hHzxG",
  "adornment_icon": "ATw-P",
  "remove": "jRaog",
  "removeButton": "UGyCF",
  "removeButtonIcon": "_7KJaE",
  "overlay": "LTfE6",
  "shown": "VlCd5",
  "dark": "KHQN-",
  "spinner": "MjRMA",
  "spin": "YtycC",
  "grid": "Q4oXb"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
